<app-startpage-container>
  <form [formGroup]="inscriptionForm">
    <div class="modal-body">
      <div class="input-group">
        <label for="email">Email <span class="required">*</span></label>
        <input id="email" type="email" formControlName="email" />
      </div>
      <div class="input-group">
        <label for="name">Nom Contact <span class="required">*</span></label>
        <input id="name" type="text" formControlName="name" />
      </div>
      <div class="input-group">
        <label for="workFunction">Fonction <span class="required">*</span></label>
        <select id="workFunction" formControlName="workFunction">
          <option ngValue="Acheteur">Acheteur</option>
          <option ngValue="Chargé d'affaires">Chargé d'affaires</option>
          <option ngValue="Technico-commercial">Technico-commercial</option>
          <option ngValue="Opérateur">Opérateur</option>
          <option ngValue="Responsable technique">Responsable technique</option>
          <option ngValue="Conducteur de travaux">Conducteur de travaux</option>
          <option ngValue="Chargé d'études">Chargé d'études</option>
          <option ngValue="Responsable bureau d'études">Responsable bureau d'études</option>
        </select>
      </div>
      <div class="input-group">
        <label for="company">Nom Enterprise <span class="required">*</span></label>
        <input id="company" type="text" formControlName="company" />
      </div>
      <div class="input-group">
        <label for="address">Adresse <span class="required">*</span></label>
        <input id="address" type="text" formControlName="address" />
      </div>
      <div class="input-group">
        <label for="codePostal">Code postal <span class="required">*</span></label>
        <input id="codePostal" type="text" pattern="[0-9]*" formControlName="codePostal" />
      </div>
      <div class="input-group">
        <label for="city">Ville <span class="required">*</span></label>
        <input id="city" type="text" formControlName="city" />
      </div>
      <div class="input-group">
        <label for="telephone">TELEPHONE <span class="required">*</span></label>
        <input id="telephone" type="tel" formControlName="phone" />
      </div>
      <div class="input-group">
        <label for="siret">N° SIRET <span class="required">*</span></label>
        <input id="siret" type="text" formControlName="siret" />
      </div>
      <div class="input-group">
        <label for="description">Mot de passe <span class="required">*</span></label>
        <input id="description" minlength="8" maxlength="24" type="password" formControlName="password" />
      </div>
      <div class="input-group">
        <label for="password_repeated">Confirmation de mot de passe <span class="required">*</span></label>
        <input id="password_repeated" minlength="8" maxlength="24" type="password" formControlName="password_repeated" />
        <p *ngIf="inscriptionForm.hasError('passwordNoMatch')">Mot de passe pas identique</p>
      </div>

      <p>Veuillez consulter et accepter nos conditions générales d'utilisation pour finaliser votre inscription.</p>
      <div class="cgu-group">
        <button class="back-button" (click)="readCGU('client')">Consulter les CGUs</button>
        <div class="check-group">
          <div class="input-group">
            <input id="cgu" type="checkbox" formControlName="cgu" />
          </div>
          <p>j'accepte</p>
        </div>
      </div>
      <div class="form-footer">
        <button class="back-button" [routerLink]="'/login'">retour</button>
        <button class="validation-button" type="submit" (click)="onSubmit()" [disabled]="!inscriptionForm.valid">S'inscrire</button>
      </div>
      <p class="error" *ngIf="error">{{ error }}</p>
    </div>
  </form> </app-startpage-container
>>
